/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const upsertShepherdProfileCalibration = /* GraphQL */ `
  mutation UpsertShepherdProfileCalibration(
    $orgId: ID!
    $input: ShepherdProfileCalibrationInput!
  ) {
    upsertShepherdProfileCalibration(orgId: $orgId, input: $input)
  }
`;
export const createShepherdProfileNote = /* GraphQL */ `
  mutation CreateShepherdProfileNote(
    $orgId: ID!
    $input: CreateShepherdProfileNoteInput!
  ) {
    createShepherdProfileNote(orgId: $orgId, input: $input)
  }
`;
export const removeShepherdProfileAssignment = /* GraphQL */ `
  mutation RemoveShepherdProfileAssignment(
    $orgId: ID!
    $profileId: ID!
    $shepherdId: ID!
  ) {
    removeShepherdProfileAssignment(
      orgId: $orgId
      profileId: $profileId
      shepherdId: $shepherdId
    )
  }
`;
export const createOrgBarRaiser = /* GraphQL */ `
  mutation CreateOrgBarRaiser($alias: String!, $orgId: ID!) {
    createOrgBarRaiser(alias: $alias, orgId: $orgId) {
      alias
      orgId
      profileId
      __typename
    }
  }
`;
export const deleteOrgBarRaiser = /* GraphQL */ `
  mutation DeleteOrgBarRaiser($profileId: ID!, $orgId: ID!) {
    deleteOrgBarRaiser(profileId: $profileId, orgId: $orgId) {
      orgId
      profileId
      roles
      __typename
    }
  }
`;
export const createElevateProfile = /* GraphQL */ `
  mutation CreateElevateProfile(
    $alias: String!
    $orgId: ID
    $isSetTimezoneId: Boolean
  ) {
    createElevateProfile(
      alias: $alias
      orgId: $orgId
      isSetTimezoneId: $isSetTimezoneId
    ) {
      alias
      profileId
      lastRefreshedAt
      __typename
    }
  }
`;
export const refreshElevateProfile = /* GraphQL */ `
  mutation RefreshElevateProfile($alias: String!, $isForceRefresh: Boolean) {
    refreshElevateProfile(alias: $alias, isForceRefresh: $isForceRefresh) {
      lastRefreshedAt
      profileId
      __typename
    }
  }
`;
export const createManagedQuip = /* GraphQL */ `
  mutation CreateManagedQuip($input: CreateManagedQuipMutationInput!) {
    createManagedQuip(input: $input) {
      quipId
      quipLink
      __typename
    }
  }
`;
export const deleteManagedQuip = /* GraphQL */ `
  mutation DeleteManagedQuip($input: DeleteManagedQuipMutationInput!) {
    deleteManagedQuip(input: $input) {
      quipLink
      success
      __typename
    }
  }
`;
export const backfillManagedTranscript = /* GraphQL */ `
  mutation BackfillManagedTranscript(
    $input: BackfillManagedTranscriptMutationInput!
  ) {
    backfillManagedTranscript(input: $input) {
      id
      cancelledAt
      completedAt
      createdAt
      failedAt
      status
      trainingId
      trainingVersion
      userId
      __typename
    }
  }
`;
export const restartPushRouting = /* GraphQL */ `
  mutation RestartPushRouting(
    $eventId: ID!
    $eventType: EventType!
    $forBarRaiser: Boolean
  ) {
    restartPushRouting(
      eventId: $eventId
      eventType: $eventType
      forBarRaiser: $forBarRaiser
    ) {
      eventId
      eventType
      success
      participantType
      message
      __typename
    }
  }
`;
export const createMeeting = /* GraphQL */ `
  mutation CreateMeeting($input: CreateMeetingInput!) {
    createMeeting(input: $input) {
      id
      subject
      body
      start
      end
      attendees
      location
      isOnlineMeeting
      meetingLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMeeting = /* GraphQL */ `
  mutation UpdateMeeting($input: UpdateMeetingInput!) {
    updateMeeting(input: $input) {
      id
      subject
      body
      start
      end
      attendees
      location
      isOnlineMeeting
      meetingLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMeeting = /* GraphQL */ `
  mutation DeleteMeeting($input: DeleteMeetingInput!) {
    deleteMeeting(input: $input)
  }
`;
export const createAnnouncement = /* GraphQL */ `
  mutation CreateAnnouncement(
    $input: CreateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    createAnnouncement(input: $input, condition: $condition) {
      id
      createdAt
      orgId
      group
      viewers
      title
      text
      status
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateAnnouncement = /* GraphQL */ `
  mutation UpdateAnnouncement(
    $input: UpdateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    updateAnnouncement(input: $input, condition: $condition) {
      id
      createdAt
      orgId
      group
      viewers
      title
      text
      status
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteAnnouncement = /* GraphQL */ `
  mutation DeleteAnnouncement(
    $input: DeleteAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    deleteAnnouncement(input: $input, condition: $condition) {
      id
      createdAt
      orgId
      group
      viewers
      title
      text
      status
      updatedAt
      owner
      __typename
    }
  }
`;
export const createAuditTrails = /* GraphQL */ `
  mutation CreateAuditTrails(
    $input: CreateAuditTrailsInput!
    $condition: ModelAuditTrailsConditionInput
  ) {
    createAuditTrails(input: $input, condition: $condition) {
      id
      createdAt
      changeJustification
      humanReadableLog
      modifiedBy
      rawOldRecord
      rawNewRecord
      recordType
      orgID
      profileID
      eventType
      eventId
      candidateId
      interviewerId
      updatedAt
      __typename
    }
  }
`;
export const updateAuditTrails = /* GraphQL */ `
  mutation UpdateAuditTrails(
    $input: UpdateAuditTrailsInput!
    $condition: ModelAuditTrailsConditionInput
  ) {
    updateAuditTrails(input: $input, condition: $condition) {
      id
      createdAt
      changeJustification
      humanReadableLog
      modifiedBy
      rawOldRecord
      rawNewRecord
      recordType
      orgID
      profileID
      eventType
      eventId
      candidateId
      interviewerId
      updatedAt
      __typename
    }
  }
`;
export const deleteAuditTrails = /* GraphQL */ `
  mutation DeleteAuditTrails(
    $input: DeleteAuditTrailsInput!
    $condition: ModelAuditTrailsConditionInput
  ) {
    deleteAuditTrails(input: $input, condition: $condition) {
      id
      createdAt
      changeJustification
      humanReadableLog
      modifiedBy
      rawOldRecord
      rawNewRecord
      recordType
      orgID
      profileID
      eventType
      eventId
      candidateId
      interviewerId
      updatedAt
      __typename
    }
  }
`;
export const createCandidate = /* GraphQL */ `
  mutation CreateCandidate(
    $input: CreateCandidateInput!
    $condition: ModelCandidateConditionInput
  ) {
    createCandidate(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      canManage
      canRead
      city
      country
      decision
      hireurl
      level
      name
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCandidate = /* GraphQL */ `
  mutation UpdateCandidate(
    $input: UpdateCandidateInput!
    $condition: ModelCandidateConditionInput
  ) {
    updateCandidate(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      canManage
      canRead
      city
      country
      decision
      hireurl
      level
      name
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCandidate = /* GraphQL */ `
  mutation DeleteCandidate(
    $input: DeleteCandidateInput!
    $condition: ModelCandidateConditionInput
  ) {
    deleteCandidate(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      canManage
      canRead
      city
      country
      decision
      hireurl
      level
      name
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      createdAt
      honeycode_uid
      group
      owner
      viewers
      commentType
      content
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      restricted
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      interviewerID
      interviewer {
        id
        honeycode_uid
        lastModifiedBy
        interviewerRole
        interviewType
        participantConfigID
        profileID
        acceptedAt
        meetingsentryID
        sendCalendarInvite
        startDateTime
        endDateTime
        isBarRaiserInterviewer
        loopEventID
        phoneScreenID
        extLoopEventID
        extPhoneScreenID
        sourceOrgID
        createdAt
        updatedAt
        __typename
      }
      interviewerProfileID
      interviewerAlias
      rating
      updatedAt
      __typename
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      createdAt
      honeycode_uid
      group
      owner
      viewers
      commentType
      content
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      restricted
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      interviewerID
      interviewer {
        id
        honeycode_uid
        lastModifiedBy
        interviewerRole
        interviewType
        participantConfigID
        profileID
        acceptedAt
        meetingsentryID
        sendCalendarInvite
        startDateTime
        endDateTime
        isBarRaiserInterviewer
        loopEventID
        phoneScreenID
        extLoopEventID
        extPhoneScreenID
        sourceOrgID
        createdAt
        updatedAt
        __typename
      }
      interviewerProfileID
      interviewerAlias
      rating
      updatedAt
      __typename
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      createdAt
      honeycode_uid
      group
      owner
      viewers
      commentType
      content
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      restricted
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      interviewerID
      interviewer {
        id
        honeycode_uid
        lastModifiedBy
        interviewerRole
        interviewType
        participantConfigID
        profileID
        acceptedAt
        meetingsentryID
        sendCalendarInvite
        startDateTime
        endDateTime
        isBarRaiserInterviewer
        loopEventID
        phoneScreenID
        extLoopEventID
        extPhoneScreenID
        sourceOrgID
        createdAt
        updatedAt
        __typename
      }
      interviewerProfileID
      interviewerAlias
      rating
      updatedAt
      __typename
    }
  }
`;
export const createInterviewer = /* GraphQL */ `
  mutation CreateInterviewer(
    $input: CreateInterviewerInput!
    $condition: ModelInterviewerConditionInput
  ) {
    createInterviewer(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      interviewerRole
      interviewType
      participantConfigID
      participantConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      acceptedAt
      meetingsentryID
      sendCalendarInvite
      startDateTime
      endDateTime
      isBarRaiserInterviewer
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      extLoopEventID
      extPhoneScreenID
      sourceOrgID
      sourceOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInterviewer = /* GraphQL */ `
  mutation UpdateInterviewer(
    $input: UpdateInterviewerInput!
    $condition: ModelInterviewerConditionInput
  ) {
    updateInterviewer(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      interviewerRole
      interviewType
      participantConfigID
      participantConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      acceptedAt
      meetingsentryID
      sendCalendarInvite
      startDateTime
      endDateTime
      isBarRaiserInterviewer
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      extLoopEventID
      extPhoneScreenID
      sourceOrgID
      sourceOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInterviewer = /* GraphQL */ `
  mutation DeleteInterviewer(
    $input: DeleteInterviewerInput!
    $condition: ModelInterviewerConditionInput
  ) {
    deleteInterviewer(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      interviewerRole
      interviewType
      participantConfigID
      participantConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      acceptedAt
      meetingsentryID
      sendCalendarInvite
      startDateTime
      endDateTime
      isBarRaiserInterviewer
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      extLoopEventID
      extPhoneScreenID
      sourceOrgID
      sourceOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLanguage = /* GraphQL */ `
  mutation CreateLanguage(
    $input: CreateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    createLanguage(input: $input, condition: $condition) {
      id
      isoCode
      recordType
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      profileId
      reading
      speaking
      writing
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      loopEventId
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      phoneScreenId
      readingRequired
      speakingRequired
      writingRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLanguage = /* GraphQL */ `
  mutation UpdateLanguage(
    $input: UpdateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    updateLanguage(input: $input, condition: $condition) {
      id
      isoCode
      recordType
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      profileId
      reading
      speaking
      writing
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      loopEventId
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      phoneScreenId
      readingRequired
      speakingRequired
      writingRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLanguage = /* GraphQL */ `
  mutation DeleteLanguage(
    $input: DeleteLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    deleteLanguage(input: $input, condition: $condition) {
      id
      isoCode
      recordType
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      profileId
      reading
      speaking
      writing
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      loopEventId
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      phoneScreenId
      readingRequired
      speakingRequired
      writingRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLoopEvent = /* GraphQL */ `
  mutation CreateLoopEvent(
    $input: CreateLoopEventInput!
    $condition: ModelLoopEventConditionInput
  ) {
    createLoopEvent(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      eventConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      locked
      lockChangedAt
      lockedbyID
      lockedby {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      maxcandidates
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      designatedRC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      eventleadID
      eventlead {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      recruitingPOCID
      recruitingPOC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      barRaiserID
      barRaiser {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      barRaiserRoutingAttempt {
        id
        loopEventID
        phoneScreenID
        participantConfigID
        isBarRaiser
        profileID
        role
        startDateTime
        endDateTime
        lastModifiedBy
        state
        meetingsentryID
        schedule
        scheduleTime
        createdAt
        updatedAt
        __typename
      }
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      candidates {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      languages {
        nextToken
        __typename
      }
      routingHistory {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLoopEvent = /* GraphQL */ `
  mutation UpdateLoopEvent(
    $input: UpdateLoopEventInput!
    $condition: ModelLoopEventConditionInput
  ) {
    updateLoopEvent(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      eventConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      locked
      lockChangedAt
      lockedbyID
      lockedby {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      maxcandidates
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      designatedRC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      eventleadID
      eventlead {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      recruitingPOCID
      recruitingPOC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      barRaiserID
      barRaiser {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      barRaiserRoutingAttempt {
        id
        loopEventID
        phoneScreenID
        participantConfigID
        isBarRaiser
        profileID
        role
        startDateTime
        endDateTime
        lastModifiedBy
        state
        meetingsentryID
        schedule
        scheduleTime
        createdAt
        updatedAt
        __typename
      }
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      candidates {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      languages {
        nextToken
        __typename
      }
      routingHistory {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLoopEvent = /* GraphQL */ `
  mutation DeleteLoopEvent(
    $input: DeleteLoopEventInput!
    $condition: ModelLoopEventConditionInput
  ) {
    deleteLoopEvent(input: $input, condition: $condition) {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      eventConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      locked
      lockChangedAt
      lockedbyID
      lockedby {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      maxcandidates
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      designatedRC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      eventleadID
      eventlead {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      recruitingPOCID
      recruitingPOC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      barRaiserID
      barRaiser {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      barRaiserRoutingAttempt {
        id
        loopEventID
        phoneScreenID
        participantConfigID
        isBarRaiser
        profileID
        role
        startDateTime
        endDateTime
        lastModifiedBy
        state
        meetingsentryID
        schedule
        scheduleTime
        createdAt
        updatedAt
        __typename
      }
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      candidates {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      languages {
        nextToken
        __typename
      }
      routingHistory {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createManagedTranscript = /* GraphQL */ `
  mutation CreateManagedTranscript(
    $input: CreateManagedTranscriptInput!
    $condition: ModelManagedTranscriptConditionInput
  ) {
    createManagedTranscript(input: $input, condition: $condition) {
      completedAt
      failedAt
      learnTrainingId
      learnTrainingVersion
      learnUserId
      status
      trainingId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateManagedTranscript = /* GraphQL */ `
  mutation UpdateManagedTranscript(
    $input: UpdateManagedTranscriptInput!
    $condition: ModelManagedTranscriptConditionInput
  ) {
    updateManagedTranscript(input: $input, condition: $condition) {
      completedAt
      failedAt
      learnTrainingId
      learnTrainingVersion
      learnUserId
      status
      trainingId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteManagedTranscript = /* GraphQL */ `
  mutation DeleteManagedTranscript(
    $input: DeleteManagedTranscriptInput!
    $condition: ModelManagedTranscriptConditionInput
  ) {
    deleteManagedTranscript(input: $input, condition: $condition) {
      completedAt
      failedAt
      learnTrainingId
      learnTrainingVersion
      learnUserId
      status
      trainingId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrgCollaborations = /* GraphQL */ `
  mutation CreateOrgCollaborations(
    $input: CreateOrgCollaborationsInput!
    $condition: ModelOrgCollaborationsConditionInput
  ) {
    createOrgCollaborations(input: $input, condition: $condition) {
      id
      groups
      isActive
      isPendingAuthorization
      pendingChangeSpec
      originatingOrgID
      originatingOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      targetOrgID
      targetOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      barRaisers
      sharedLoopParticipants {
        originParticipantId
        targetParticipantId
        mode
        __typename
      }
      sharedPSParticipants {
        originParticipantId
        targetParticipantId
        mode
        __typename
      }
      originParticipantIDs
      originParticipants {
        nextToken
        __typename
      }
      targetParticipantIDs
      targetParticipants {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrgCollaborations = /* GraphQL */ `
  mutation UpdateOrgCollaborations(
    $input: UpdateOrgCollaborationsInput!
    $condition: ModelOrgCollaborationsConditionInput
  ) {
    updateOrgCollaborations(input: $input, condition: $condition) {
      id
      groups
      isActive
      isPendingAuthorization
      pendingChangeSpec
      originatingOrgID
      originatingOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      targetOrgID
      targetOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      barRaisers
      sharedLoopParticipants {
        originParticipantId
        targetParticipantId
        mode
        __typename
      }
      sharedPSParticipants {
        originParticipantId
        targetParticipantId
        mode
        __typename
      }
      originParticipantIDs
      originParticipants {
        nextToken
        __typename
      }
      targetParticipantIDs
      targetParticipants {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgCollaborations = /* GraphQL */ `
  mutation DeleteOrgCollaborations(
    $input: DeleteOrgCollaborationsInput!
    $condition: ModelOrgCollaborationsConditionInput
  ) {
    deleteOrgCollaborations(input: $input, condition: $condition) {
      id
      groups
      isActive
      isPendingAuthorization
      pendingChangeSpec
      originatingOrgID
      originatingOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      targetOrgID
      targetOrg {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      barRaisers
      sharedLoopParticipants {
        originParticipantId
        targetParticipantId
        mode
        __typename
      }
      sharedPSParticipants {
        originParticipantId
        targetParticipantId
        mode
        __typename
      }
      originParticipantIDs
      originParticipants {
        nextToken
        __typename
      }
      targetParticipantIDs
      targetParticipants {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrgLoopPSConfigurations = /* GraphQL */ `
  mutation CreateOrgLoopPSConfigurations(
    $input: CreateOrgLoopPSConfigurationsInput!
    $condition: ModelOrgLoopPSConfigurationsConditionInput
  ) {
    createOrgLoopPSConfigurations(input: $input, condition: $condition) {
      id
      group
      configType
      isActive
      name
      description
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationParticipants {
        nextToken
        __typename
      }
      calibrationConfigID
      calibrationConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      competencies {
        level
        __typename
      }
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      participantConfigs {
        nextToken
        __typename
      }
      loopEvents {
        nextToken
        __typename
      }
      phoneScreens {
        nextToken
        __typename
      }
      pushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      calibrations {
        nextToken
        __typename
      }
      interviews {
        nextToken
        __typename
      }
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrgLoopPSConfigurations = /* GraphQL */ `
  mutation UpdateOrgLoopPSConfigurations(
    $input: UpdateOrgLoopPSConfigurationsInput!
    $condition: ModelOrgLoopPSConfigurationsConditionInput
  ) {
    updateOrgLoopPSConfigurations(input: $input, condition: $condition) {
      id
      group
      configType
      isActive
      name
      description
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationParticipants {
        nextToken
        __typename
      }
      calibrationConfigID
      calibrationConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      competencies {
        level
        __typename
      }
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      participantConfigs {
        nextToken
        __typename
      }
      loopEvents {
        nextToken
        __typename
      }
      phoneScreens {
        nextToken
        __typename
      }
      pushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      calibrations {
        nextToken
        __typename
      }
      interviews {
        nextToken
        __typename
      }
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgLoopPSConfigurations = /* GraphQL */ `
  mutation DeleteOrgLoopPSConfigurations(
    $input: DeleteOrgLoopPSConfigurationsInput!
    $condition: ModelOrgLoopPSConfigurationsConditionInput
  ) {
    deleteOrgLoopPSConfigurations(input: $input, condition: $condition) {
      id
      group
      configType
      isActive
      name
      description
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationParticipants {
        nextToken
        __typename
      }
      calibrationConfigID
      calibrationConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      competencies {
        level
        __typename
      }
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      participantConfigs {
        nextToken
        __typename
      }
      loopEvents {
        nextToken
        __typename
      }
      phoneScreens {
        nextToken
        __typename
      }
      pushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      calibrations {
        nextToken
        __typename
      }
      interviews {
        nextToken
        __typename
      }
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $input: CreateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    createOrganization(input: $input, condition: $condition) {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      eventTags {
        group
        value
        __typename
      }
      orgCollaborationsInbound {
        nextToken
        __typename
      }
      orgCollaborationsOutbound {
        nextToken
        __typename
      }
      loopPSConfigs {
        nextToken
        __typename
      }
      loopEvents {
        nextToken
        __typename
      }
      phoneScreens {
        nextToken
        __typename
      }
      interviews {
        nextToken
        __typename
      }
      members {
        nextToken
        __typename
      }
      roleLDAPGroups {
        nextToken
        __typename
      }
      roleGroups {
        nextToken
        __typename
      }
      calibrationShepherdMode
      defaultCalibrationShepherd
      trainings {
        nextToken
        __typename
      }
      competencies {
        name
        description
        __typename
      }
      advancedSettings {
        enablePromoHub
        enableApss
        enableInterviewManagement
        enableLoopQuipExport
        enablePhoneScreenQuipExport
        enablePushRouting
        __typename
      }
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $input: UpdateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    updateOrganization(input: $input, condition: $condition) {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      eventTags {
        group
        value
        __typename
      }
      orgCollaborationsInbound {
        nextToken
        __typename
      }
      orgCollaborationsOutbound {
        nextToken
        __typename
      }
      loopPSConfigs {
        nextToken
        __typename
      }
      loopEvents {
        nextToken
        __typename
      }
      phoneScreens {
        nextToken
        __typename
      }
      interviews {
        nextToken
        __typename
      }
      members {
        nextToken
        __typename
      }
      roleLDAPGroups {
        nextToken
        __typename
      }
      roleGroups {
        nextToken
        __typename
      }
      calibrationShepherdMode
      defaultCalibrationShepherd
      trainings {
        nextToken
        __typename
      }
      competencies {
        name
        description
        __typename
      }
      advancedSettings {
        enablePromoHub
        enableApss
        enableInterviewManagement
        enableLoopQuipExport
        enablePhoneScreenQuipExport
        enablePushRouting
        __typename
      }
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization(
    $input: DeleteOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    deleteOrganization(input: $input, condition: $condition) {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      eventTags {
        group
        value
        __typename
      }
      orgCollaborationsInbound {
        nextToken
        __typename
      }
      orgCollaborationsOutbound {
        nextToken
        __typename
      }
      loopPSConfigs {
        nextToken
        __typename
      }
      loopEvents {
        nextToken
        __typename
      }
      phoneScreens {
        nextToken
        __typename
      }
      interviews {
        nextToken
        __typename
      }
      members {
        nextToken
        __typename
      }
      roleLDAPGroups {
        nextToken
        __typename
      }
      roleGroups {
        nextToken
        __typename
      }
      calibrationShepherdMode
      defaultCalibrationShepherd
      trainings {
        nextToken
        __typename
      }
      competencies {
        name
        description
        __typename
      }
      advancedSettings {
        enablePromoHub
        enableApss
        enableInterviewManagement
        enableLoopQuipExport
        enablePhoneScreenQuipExport
        enablePushRouting
        __typename
      }
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPhoneScreen = /* GraphQL */ `
  mutation CreatePhoneScreen(
    $input: CreatePhoneScreenInput!
    $condition: ModelPhoneScreenConditionInput
  ) {
    createPhoneScreen(input: $input, condition: $condition) {
      id
      lastModifiedBy
      eventConfigID
      eventConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      eventType
      locked
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      restrictedevent
      status
      taglist
      designatedRCID
      designatedRC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      candidates {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      languages {
        nextToken
        __typename
      }
      routingHistory {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePhoneScreen = /* GraphQL */ `
  mutation UpdatePhoneScreen(
    $input: UpdatePhoneScreenInput!
    $condition: ModelPhoneScreenConditionInput
  ) {
    updatePhoneScreen(input: $input, condition: $condition) {
      id
      lastModifiedBy
      eventConfigID
      eventConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      eventType
      locked
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      restrictedevent
      status
      taglist
      designatedRCID
      designatedRC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      candidates {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      languages {
        nextToken
        __typename
      }
      routingHistory {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePhoneScreen = /* GraphQL */ `
  mutation DeletePhoneScreen(
    $input: DeletePhoneScreenInput!
    $condition: ModelPhoneScreenConditionInput
  ) {
    deletePhoneScreen(input: $input, condition: $condition) {
      id
      lastModifiedBy
      eventConfigID
      eventConfig {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      eventType
      locked
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      restrictedevent
      status
      taglist
      designatedRCID
      designatedRC {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      candidates {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      languages {
        nextToken
        __typename
      }
      routingHistory {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProfile = /* GraphQL */ `
  mutation CreateProfile(
    $input: CreateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    createProfile(input: $input, condition: $condition) {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      shepherds {
        nextToken
        __typename
      }
      calibrations {
        nextToken
        __typename
      }
      cohortMembers {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      availabilities {
        nextToken
        __typename
      }
      routingAttempts {
        nextToken
        __typename
      }
      designatedRCLoops {
        nextToken
        __typename
      }
      eventLeadLoops {
        nextToken
        __typename
      }
      recruitingPOCLoops {
        nextToken
        __typename
      }
      designatedRCPhoneScreens {
        nextToken
        __typename
      }
      lockedLoops {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      orgs {
        nextToken
        __typename
      }
      lastRefreshedDate
      languages {
        nextToken
        __typename
      }
      barRaiserEvents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProfile = /* GraphQL */ `
  mutation UpdateProfile(
    $input: UpdateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    updateProfile(input: $input, condition: $condition) {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      shepherds {
        nextToken
        __typename
      }
      calibrations {
        nextToken
        __typename
      }
      cohortMembers {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      availabilities {
        nextToken
        __typename
      }
      routingAttempts {
        nextToken
        __typename
      }
      designatedRCLoops {
        nextToken
        __typename
      }
      eventLeadLoops {
        nextToken
        __typename
      }
      recruitingPOCLoops {
        nextToken
        __typename
      }
      designatedRCPhoneScreens {
        nextToken
        __typename
      }
      lockedLoops {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      orgs {
        nextToken
        __typename
      }
      lastRefreshedDate
      languages {
        nextToken
        __typename
      }
      barRaiserEvents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProfile = /* GraphQL */ `
  mutation DeleteProfile(
    $input: DeleteProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    deleteProfile(input: $input, condition: $condition) {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      shepherds {
        nextToken
        __typename
      }
      calibrations {
        nextToken
        __typename
      }
      cohortMembers {
        nextToken
        __typename
      }
      interviewers {
        nextToken
        __typename
      }
      availabilities {
        nextToken
        __typename
      }
      routingAttempts {
        nextToken
        __typename
      }
      designatedRCLoops {
        nextToken
        __typename
      }
      eventLeadLoops {
        nextToken
        __typename
      }
      recruitingPOCLoops {
        nextToken
        __typename
      }
      designatedRCPhoneScreens {
        nextToken
        __typename
      }
      lockedLoops {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      orgs {
        nextToken
        __typename
      }
      lastRefreshedDate
      languages {
        nextToken
        __typename
      }
      barRaiserEvents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProfileAvailability = /* GraphQL */ `
  mutation CreateProfileAvailability(
    $input: CreateProfileAvailabilityInput!
    $condition: ModelProfileAvailabilityConditionInput
  ) {
    createProfileAvailability(input: $input, condition: $condition) {
      id
      expired
      hireurl
      orgID
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      requester
      state
      availabilityDate
      availabilityOpen
      availabilityClose
      meetingsentryID
      sendCalendarInvite
      availabilitySeriesID
      availabilitySeries {
        id
        expired
        hireurl
        orgID
        profileID
        requester
        state
        availabilityDate
        availabilityOpen
        availabilityClose
        meetingsentryID
        sendCalendarInvite
        availabilitySeriesID
        recurringEndDate
        recursion
        rrule
        createdAt
        updatedAt
        __typename
      }
      recurringEndDate
      recursion
      rrule
      occurrences {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProfileAvailability = /* GraphQL */ `
  mutation UpdateProfileAvailability(
    $input: UpdateProfileAvailabilityInput!
    $condition: ModelProfileAvailabilityConditionInput
  ) {
    updateProfileAvailability(input: $input, condition: $condition) {
      id
      expired
      hireurl
      orgID
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      requester
      state
      availabilityDate
      availabilityOpen
      availabilityClose
      meetingsentryID
      sendCalendarInvite
      availabilitySeriesID
      availabilitySeries {
        id
        expired
        hireurl
        orgID
        profileID
        requester
        state
        availabilityDate
        availabilityOpen
        availabilityClose
        meetingsentryID
        sendCalendarInvite
        availabilitySeriesID
        recurringEndDate
        recursion
        rrule
        createdAt
        updatedAt
        __typename
      }
      recurringEndDate
      recursion
      rrule
      occurrences {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProfileAvailability = /* GraphQL */ `
  mutation DeleteProfileAvailability(
    $input: DeleteProfileAvailabilityInput!
    $condition: ModelProfileAvailabilityConditionInput
  ) {
    deleteProfileAvailability(input: $input, condition: $condition) {
      id
      expired
      hireurl
      orgID
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      requester
      state
      availabilityDate
      availabilityOpen
      availabilityClose
      meetingsentryID
      sendCalendarInvite
      availabilitySeriesID
      availabilitySeries {
        id
        expired
        hireurl
        orgID
        profileID
        requester
        state
        availabilityDate
        availabilityOpen
        availabilityClose
        meetingsentryID
        sendCalendarInvite
        availabilitySeriesID
        recurringEndDate
        recursion
        rrule
        createdAt
        updatedAt
        __typename
      }
      recurringEndDate
      recursion
      rrule
      occurrences {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProfileCalibration = /* GraphQL */ `
  mutation CreateProfileCalibration(
    $input: CreateProfileCalibrationInput!
    $condition: ModelProfileCalibrationConditionInput
  ) {
    createProfileCalibration(input: $input, condition: $condition) {
      profileId
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      calibrationId
      calibration {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      status
      cohortEnteredAt
      cohortExitedAt
      independentCount
      reverseShadowCount
      reviewCount
      shadowCount
      calibratedAt
      changeJustification
      lastModifiedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProfileCalibration = /* GraphQL */ `
  mutation UpdateProfileCalibration(
    $input: UpdateProfileCalibrationInput!
    $condition: ModelProfileCalibrationConditionInput
  ) {
    updateProfileCalibration(input: $input, condition: $condition) {
      profileId
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      calibrationId
      calibration {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      status
      cohortEnteredAt
      cohortExitedAt
      independentCount
      reverseShadowCount
      reviewCount
      shadowCount
      calibratedAt
      changeJustification
      lastModifiedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProfileCalibration = /* GraphQL */ `
  mutation DeleteProfileCalibration(
    $input: DeleteProfileCalibrationInput!
    $condition: ModelProfileCalibrationConditionInput
  ) {
    deleteProfileCalibration(input: $input, condition: $condition) {
      profileId
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      calibrationId
      calibration {
        id
        group
        configType
        isActive
        name
        description
        orgID
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        maxShadowPoolSize
        calibrationConfigID
        isPushRouting
        concurrencyGroup
        brMode
        candidateLevels
        duration
        breakDuration
        maxShadowParticipants
        participantConfigIDs
        prebriefRequired
        prebriefInformation
        createdAt
        updatedAt
        __typename
      }
      status
      cohortEnteredAt
      cohortExitedAt
      independentCount
      reverseShadowCount
      reviewCount
      shadowCount
      calibratedAt
      changeJustification
      lastModifiedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProfileOrganizationV2 = /* GraphQL */ `
  mutation CreateProfileOrganizationV2(
    $input: CreateProfileOrganizationV2Input!
    $condition: ModelProfileOrganizationV2ConditionInput
  ) {
    createProfileOrganizationV2(input: $input, condition: $condition) {
      profileID
      group
      orgID
      organization {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProfileOrganizationV2 = /* GraphQL */ `
  mutation UpdateProfileOrganizationV2(
    $input: UpdateProfileOrganizationV2Input!
    $condition: ModelProfileOrganizationV2ConditionInput
  ) {
    updateProfileOrganizationV2(input: $input, condition: $condition) {
      profileID
      group
      orgID
      organization {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProfileOrganizationV2 = /* GraphQL */ `
  mutation DeleteProfileOrganizationV2(
    $input: DeleteProfileOrganizationV2Input!
    $condition: ModelProfileOrganizationV2ConditionInput
  ) {
    deleteProfileOrganizationV2(input: $input, condition: $condition) {
      profileID
      group
      orgID
      organization {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPromoPath = /* GraphQL */ `
  mutation CreatePromoPath(
    $input: CreatePromoPathInput!
    $condition: ModelPromoPathConditionInput
  ) {
    createPromoPath(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      allowAttachments
      categoryIds
      name
      pathType
      role
      startLevel
      status
      suggestedLPs
      targetLevel
      candidate
      targetDate
      totalCompleted
      totalRequired
      manager
      templateId
      __typename
    }
  }
`;
export const updatePromoPath = /* GraphQL */ `
  mutation UpdatePromoPath(
    $input: UpdatePromoPathInput!
    $condition: ModelPromoPathConditionInput
  ) {
    updatePromoPath(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      allowAttachments
      categoryIds
      name
      pathType
      role
      startLevel
      status
      suggestedLPs
      targetLevel
      candidate
      targetDate
      totalCompleted
      totalRequired
      manager
      templateId
      __typename
    }
  }
`;
export const deletePromoPath = /* GraphQL */ `
  mutation DeletePromoPath(
    $input: DeletePromoPathInput!
    $condition: ModelPromoPathConditionInput
  ) {
    deletePromoPath(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      allowAttachments
      categoryIds
      name
      pathType
      role
      startLevel
      status
      suggestedLPs
      targetLevel
      candidate
      targetDate
      totalCompleted
      totalRequired
      manager
      templateId
      __typename
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      description
      isDefault
      name
      role
      status
      __typename
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      description
      isDefault
      name
      role
      status
      __typename
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      description
      isDefault
      name
      role
      status
      __typename
    }
  }
`;
export const createFileRecord = /* GraphQL */ `
  mutation CreateFileRecord(
    $input: CreateFileRecordInput!
    $condition: ModelFileRecordConditionInput
  ) {
    createFileRecord(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      fileDateModified
      fileName
      fileSizeBytes
      s3Key
      storageIdKey
      status
      __typename
    }
  }
`;
export const updateFileRecord = /* GraphQL */ `
  mutation UpdateFileRecord(
    $input: UpdateFileRecordInput!
    $condition: ModelFileRecordConditionInput
  ) {
    updateFileRecord(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      fileDateModified
      fileName
      fileSizeBytes
      s3Key
      storageIdKey
      status
      __typename
    }
  }
`;
export const deleteFileRecord = /* GraphQL */ `
  mutation DeleteFileRecord(
    $input: DeleteFileRecordInput!
    $condition: ModelFileRecordConditionInput
  ) {
    deleteFileRecord(input: $input, condition: $condition) {
      createdAt
      id
      owner
      updatedAt
      fileDateModified
      fileName
      fileSizeBytes
      s3Key
      storageIdKey
      status
      __typename
    }
  }
`;
export const createPeerReview = /* GraphQL */ `
  mutation CreatePeerReview(
    $input: CreatePeerReviewInput!
    $condition: ModelPeerReviewConditionInput
  ) {
    createPeerReview(input: $input, condition: $condition) {
      createdAt
      id
      owner
      coOwners
      updatedAt
      content
      requiredBy
      reviewedContentVersion
      reviewStatus
      reviewType
      candidatePathId
      reviewerAlias
      workSummaryId
      __typename
    }
  }
`;
export const updatePeerReview = /* GraphQL */ `
  mutation UpdatePeerReview(
    $input: UpdatePeerReviewInput!
    $condition: ModelPeerReviewConditionInput
  ) {
    updatePeerReview(input: $input, condition: $condition) {
      createdAt
      id
      owner
      coOwners
      updatedAt
      content
      requiredBy
      reviewedContentVersion
      reviewStatus
      reviewType
      candidatePathId
      reviewerAlias
      workSummaryId
      __typename
    }
  }
`;
export const deletePeerReview = /* GraphQL */ `
  mutation DeletePeerReview(
    $input: DeletePeerReviewInput!
    $condition: ModelPeerReviewConditionInput
  ) {
    deletePeerReview(input: $input, condition: $condition) {
      createdAt
      id
      owner
      coOwners
      updatedAt
      content
      requiredBy
      reviewedContentVersion
      reviewStatus
      reviewType
      candidatePathId
      reviewerAlias
      workSummaryId
      __typename
    }
  }
`;
export const createWorkSummary = /* GraphQL */ `
  mutation CreateWorkSummary(
    $input: CreateWorkSummaryInput!
    $condition: ModelWorkSummaryConditionInput
  ) {
    createWorkSummary(input: $input, condition: $condition) {
      createdAt
      id
      owner
      coOwners
      updatedAt
      alias
      candidatePathId
      categoryIds
      content
      contentVersion
      leadershipPrinciples
      status
      statusReason
      submittedAt
      title
      type
      __typename
    }
  }
`;
export const updateWorkSummary = /* GraphQL */ `
  mutation UpdateWorkSummary(
    $input: UpdateWorkSummaryInput!
    $condition: ModelWorkSummaryConditionInput
  ) {
    updateWorkSummary(input: $input, condition: $condition) {
      createdAt
      id
      owner
      coOwners
      updatedAt
      alias
      candidatePathId
      categoryIds
      content
      contentVersion
      leadershipPrinciples
      status
      statusReason
      submittedAt
      title
      type
      __typename
    }
  }
`;
export const deleteWorkSummary = /* GraphQL */ `
  mutation DeleteWorkSummary(
    $input: DeleteWorkSummaryInput!
    $condition: ModelWorkSummaryConditionInput
  ) {
    deleteWorkSummary(input: $input, condition: $condition) {
      createdAt
      id
      owner
      coOwners
      updatedAt
      alias
      candidatePathId
      categoryIds
      content
      contentVersion
      leadershipPrinciples
      status
      statusReason
      submittedAt
      title
      type
      __typename
    }
  }
`;
export const createQuestionBankTeam = /* GraphQL */ `
  mutation CreateQuestionBankTeam(
    $input: CreateQuestionBankTeamInput!
    $condition: ModelQuestionBankTeamConditionInput
  ) {
    createQuestionBankTeam(input: $input, condition: $condition) {
      group
      id
      name
      categories {
        nextToken
        __typename
      }
      interviewTemplates {
        nextToken
        __typename
      }
      interviewerRoles {
        nextToken
        __typename
      }
      jobRoles {
        nextToken
        __typename
      }
      questions {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestionBankTeam = /* GraphQL */ `
  mutation UpdateQuestionBankTeam(
    $input: UpdateQuestionBankTeamInput!
    $condition: ModelQuestionBankTeamConditionInput
  ) {
    updateQuestionBankTeam(input: $input, condition: $condition) {
      group
      id
      name
      categories {
        nextToken
        __typename
      }
      interviewTemplates {
        nextToken
        __typename
      }
      interviewerRoles {
        nextToken
        __typename
      }
      jobRoles {
        nextToken
        __typename
      }
      questions {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestionBankTeam = /* GraphQL */ `
  mutation DeleteQuestionBankTeam(
    $input: DeleteQuestionBankTeamInput!
    $condition: ModelQuestionBankTeamConditionInput
  ) {
    deleteQuestionBankTeam(input: $input, condition: $condition) {
      group
      id
      name
      categories {
        nextToken
        __typename
      }
      interviewTemplates {
        nextToken
        __typename
      }
      interviewerRoles {
        nextToken
        __typename
      }
      jobRoles {
        nextToken
        __typename
      }
      questions {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestionBankCategory = /* GraphQL */ `
  mutation CreateQuestionBankCategory(
    $input: CreateQuestionBankCategoryInput!
    $condition: ModelQuestionBankCategoryConditionInput
  ) {
    createQuestionBankCategory(input: $input, condition: $condition) {
      group
      id
      name
      description
      questions {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestionBankCategory = /* GraphQL */ `
  mutation UpdateQuestionBankCategory(
    $input: UpdateQuestionBankCategoryInput!
    $condition: ModelQuestionBankCategoryConditionInput
  ) {
    updateQuestionBankCategory(input: $input, condition: $condition) {
      group
      id
      name
      description
      questions {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestionBankCategory = /* GraphQL */ `
  mutation DeleteQuestionBankCategory(
    $input: DeleteQuestionBankCategoryInput!
    $condition: ModelQuestionBankCategoryConditionInput
  ) {
    deleteQuestionBankCategory(input: $input, condition: $condition) {
      group
      id
      name
      description
      questions {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestionBankJobRole = /* GraphQL */ `
  mutation CreateQuestionBankJobRole(
    $input: CreateQuestionBankJobRoleInput!
    $condition: ModelQuestionBankJobRoleConditionInput
  ) {
    createQuestionBankJobRole(input: $input, condition: $condition) {
      group
      id
      name
      description
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestionBankJobRole = /* GraphQL */ `
  mutation UpdateQuestionBankJobRole(
    $input: UpdateQuestionBankJobRoleInput!
    $condition: ModelQuestionBankJobRoleConditionInput
  ) {
    updateQuestionBankJobRole(input: $input, condition: $condition) {
      group
      id
      name
      description
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestionBankJobRole = /* GraphQL */ `
  mutation DeleteQuestionBankJobRole(
    $input: DeleteQuestionBankJobRoleInput!
    $condition: ModelQuestionBankJobRoleConditionInput
  ) {
    deleteQuestionBankJobRole(input: $input, condition: $condition) {
      group
      id
      name
      description
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestionBankInterviewerRole = /* GraphQL */ `
  mutation CreateQuestionBankInterviewerRole(
    $input: CreateQuestionBankInterviewerRoleInput!
    $condition: ModelQuestionBankInterviewerRoleConditionInput
  ) {
    createQuestionBankInterviewerRole(input: $input, condition: $condition) {
      group
      id
      name
      description
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestionBankInterviewerRole = /* GraphQL */ `
  mutation UpdateQuestionBankInterviewerRole(
    $input: UpdateQuestionBankInterviewerRoleInput!
    $condition: ModelQuestionBankInterviewerRoleConditionInput
  ) {
    updateQuestionBankInterviewerRole(input: $input, condition: $condition) {
      group
      id
      name
      description
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestionBankInterviewerRole = /* GraphQL */ `
  mutation DeleteQuestionBankInterviewerRole(
    $input: DeleteQuestionBankInterviewerRoleInput!
    $condition: ModelQuestionBankInterviewerRoleConditionInput
  ) {
    deleteQuestionBankInterviewerRole(input: $input, condition: $condition) {
      group
      id
      name
      description
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestionBankQuestion = /* GraphQL */ `
  mutation CreateQuestionBankQuestion(
    $input: CreateQuestionBankQuestionInput!
    $condition: ModelQuestionBankQuestionConditionInput
  ) {
    createQuestionBankQuestion(input: $input, condition: $condition) {
      group
      id
      category {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      categoryID
      name
      description
      status
      shareability
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestionBankQuestion = /* GraphQL */ `
  mutation UpdateQuestionBankQuestion(
    $input: UpdateQuestionBankQuestionInput!
    $condition: ModelQuestionBankQuestionConditionInput
  ) {
    updateQuestionBankQuestion(input: $input, condition: $condition) {
      group
      id
      category {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      categoryID
      name
      description
      status
      shareability
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestionBankQuestion = /* GraphQL */ `
  mutation DeleteQuestionBankQuestion(
    $input: DeleteQuestionBankQuestionInput!
    $condition: ModelQuestionBankQuestionConditionInput
  ) {
    deleteQuestionBankQuestion(input: $input, condition: $condition) {
      group
      id
      category {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      categoryID
      name
      description
      status
      shareability
      interviewTemplates {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestionBankInterviewTemplateQuestion = /* GraphQL */ `
  mutation CreateQuestionBankInterviewTemplateQuestion(
    $input: CreateQuestionBankInterviewTemplateQuestionInput!
    $condition: ModelQuestionBankInterviewTemplateQuestionConditionInput
  ) {
    createQuestionBankInterviewTemplateQuestion(
      input: $input
      condition: $condition
    ) {
      group
      interviewTemplate {
        group
        id
        name
        description
        jobLevel
        interviewerRoleID
        jobRoleID
        teamID
        createdAt
        updatedAt
        __typename
      }
      interviewTemplateID
      question {
        group
        id
        categoryID
        name
        description
        status
        shareability
        teamID
        createdAt
        updatedAt
        __typename
      }
      questionID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestionBankInterviewTemplateQuestion = /* GraphQL */ `
  mutation UpdateQuestionBankInterviewTemplateQuestion(
    $input: UpdateQuestionBankInterviewTemplateQuestionInput!
    $condition: ModelQuestionBankInterviewTemplateQuestionConditionInput
  ) {
    updateQuestionBankInterviewTemplateQuestion(
      input: $input
      condition: $condition
    ) {
      group
      interviewTemplate {
        group
        id
        name
        description
        jobLevel
        interviewerRoleID
        jobRoleID
        teamID
        createdAt
        updatedAt
        __typename
      }
      interviewTemplateID
      question {
        group
        id
        categoryID
        name
        description
        status
        shareability
        teamID
        createdAt
        updatedAt
        __typename
      }
      questionID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestionBankInterviewTemplateQuestion = /* GraphQL */ `
  mutation DeleteQuestionBankInterviewTemplateQuestion(
    $input: DeleteQuestionBankInterviewTemplateQuestionInput!
    $condition: ModelQuestionBankInterviewTemplateQuestionConditionInput
  ) {
    deleteQuestionBankInterviewTemplateQuestion(
      input: $input
      condition: $condition
    ) {
      group
      interviewTemplate {
        group
        id
        name
        description
        jobLevel
        interviewerRoleID
        jobRoleID
        teamID
        createdAt
        updatedAt
        __typename
      }
      interviewTemplateID
      question {
        group
        id
        categoryID
        name
        description
        status
        shareability
        teamID
        createdAt
        updatedAt
        __typename
      }
      questionID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestionBankInterviewTemplate = /* GraphQL */ `
  mutation CreateQuestionBankInterviewTemplate(
    $input: CreateQuestionBankInterviewTemplateInput!
    $condition: ModelQuestionBankInterviewTemplateConditionInput
  ) {
    createQuestionBankInterviewTemplate(input: $input, condition: $condition) {
      group
      id
      name
      description
      jobLevel
      interviewerRole {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      interviewerRoleID
      jobRole {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      jobRoleID
      questions {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestionBankInterviewTemplate = /* GraphQL */ `
  mutation UpdateQuestionBankInterviewTemplate(
    $input: UpdateQuestionBankInterviewTemplateInput!
    $condition: ModelQuestionBankInterviewTemplateConditionInput
  ) {
    updateQuestionBankInterviewTemplate(input: $input, condition: $condition) {
      group
      id
      name
      description
      jobLevel
      interviewerRole {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      interviewerRoleID
      jobRole {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      jobRoleID
      questions {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestionBankInterviewTemplate = /* GraphQL */ `
  mutation DeleteQuestionBankInterviewTemplate(
    $input: DeleteQuestionBankInterviewTemplateInput!
    $condition: ModelQuestionBankInterviewTemplateConditionInput
  ) {
    deleteQuestionBankInterviewTemplate(input: $input, condition: $condition) {
      group
      id
      name
      description
      jobLevel
      interviewerRole {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      interviewerRoleID
      jobRole {
        group
        id
        name
        description
        teamID
        createdAt
        updatedAt
        __typename
      }
      jobRoleID
      questions {
        nextToken
        __typename
      }
      team {
        group
        id
        name
        createdAt
        updatedAt
        __typename
      }
      teamID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrgRoleLDAPGroups = /* GraphQL */ `
  mutation CreateOrgRoleLDAPGroups(
    $input: CreateOrgRoleLDAPGroupsInput!
    $condition: ModelOrgRoleLDAPGroupsConditionInput
  ) {
    createOrgRoleLDAPGroups(input: $input, condition: $condition) {
      id
      group
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrgRoleLDAPGroups = /* GraphQL */ `
  mutation UpdateOrgRoleLDAPGroups(
    $input: UpdateOrgRoleLDAPGroupsInput!
    $condition: ModelOrgRoleLDAPGroupsConditionInput
  ) {
    updateOrgRoleLDAPGroups(input: $input, condition: $condition) {
      id
      group
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgRoleLDAPGroups = /* GraphQL */ `
  mutation DeleteOrgRoleLDAPGroups(
    $input: DeleteOrgRoleLDAPGroupsInput!
    $condition: ModelOrgRoleLDAPGroupsConditionInput
  ) {
    deleteOrgRoleLDAPGroups(input: $input, condition: $condition) {
      id
      group
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRolePermissionGroup = /* GraphQL */ `
  mutation CreateRolePermissionGroup(
    $input: CreateRolePermissionGroupInput!
    $condition: ModelRolePermissionGroupConditionInput
  ) {
    createRolePermissionGroup(input: $input, condition: $condition) {
      id
      app
      displayName
      teamId
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRolePermissionGroup = /* GraphQL */ `
  mutation UpdateRolePermissionGroup(
    $input: UpdateRolePermissionGroupInput!
    $condition: ModelRolePermissionGroupConditionInput
  ) {
    updateRolePermissionGroup(input: $input, condition: $condition) {
      id
      app
      displayName
      teamId
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRolePermissionGroup = /* GraphQL */ `
  mutation DeleteRolePermissionGroup(
    $input: DeleteRolePermissionGroupInput!
    $condition: ModelRolePermissionGroupConditionInput
  ) {
    deleteRolePermissionGroup(input: $input, condition: $condition) {
      id
      app
      displayName
      teamId
      orgID
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRoutingAttempt = /* GraphQL */ `
  mutation CreateRoutingAttempt(
    $input: CreateRoutingAttemptInput!
    $condition: ModelRoutingAttemptConditionInput
  ) {
    createRoutingAttempt(input: $input, condition: $condition) {
      id
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      participantConfigID
      isBarRaiser
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      role
      startDateTime
      endDateTime
      pushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      normalizedPushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      lastModifiedBy
      state
      meetingsentryID
      schedule
      scheduleTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRoutingAttempt = /* GraphQL */ `
  mutation UpdateRoutingAttempt(
    $input: UpdateRoutingAttemptInput!
    $condition: ModelRoutingAttemptConditionInput
  ) {
    updateRoutingAttempt(input: $input, condition: $condition) {
      id
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      participantConfigID
      isBarRaiser
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      role
      startDateTime
      endDateTime
      pushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      normalizedPushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      lastModifiedBy
      state
      meetingsentryID
      schedule
      scheduleTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRoutingAttempt = /* GraphQL */ `
  mutation DeleteRoutingAttempt(
    $input: DeleteRoutingAttemptInput!
    $condition: ModelRoutingAttemptConditionInput
  ) {
    deleteRoutingAttempt(input: $input, condition: $condition) {
      id
      loopEventID
      loopEvent {
        id
        honeycode_uid
        lastModifiedBy
        eventConfigID
        locked
        lockChangedAt
        lockedbyID
        maxcandidates
        orgID
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        status
        taglist
        designatedRCID
        eventleadID
        recruitingPOCID
        barRaiserID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        debriefbooked
        debriefNote
        debriefmeetingentryIDs
        prebriefbooked
        prebriefNote
        prebriefmeetingentryIDs
        location
        virtualevent
        is_template
        template_name
        template_description
        template_creator_alias
        source_template_id
        eventType
        createdAt
        updatedAt
        __typename
      }
      phoneScreenID
      phoneScreen {
        id
        lastModifiedBy
        eventConfigID
        eventType
        locked
        orgID
        restrictedevent
        status
        taglist
        designatedRCID
        availabilityID
        calendarplaceholdersent
        date
        eventstarttime
        eventendtime
        createdAt
        updatedAt
        __typename
      }
      participantConfigID
      isBarRaiser
      profileID
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      role
      startDateTime
      endDateTime
      pushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      normalizedPushRoutingWeight {
        timeSinceLastInterview
        timeZoneMatch
        diversityInterviewer
        languageMatch
        pendingRoutingAttempt
        shadowCompletion
        orgCollaborationInbound
        randomness
        __typename
      }
      lastModifiedBy
      state
      meetingsentryID
      schedule
      scheduleTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createShepherdProfile = /* GraphQL */ `
  mutation CreateShepherdProfile(
    $input: CreateShepherdProfileInput!
    $condition: ModelShepherdProfileConditionInput
  ) {
    createShepherdProfile(input: $input, condition: $condition) {
      assignedAt
      group
      profileId
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      shepherdId
      shepherd {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      isOrgDefault
      lastModifiedBy
      priority
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateShepherdProfile = /* GraphQL */ `
  mutation UpdateShepherdProfile(
    $input: UpdateShepherdProfileInput!
    $condition: ModelShepherdProfileConditionInput
  ) {
    updateShepherdProfile(input: $input, condition: $condition) {
      assignedAt
      group
      profileId
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      shepherdId
      shepherd {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      isOrgDefault
      lastModifiedBy
      priority
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteShepherdProfile = /* GraphQL */ `
  mutation DeleteShepherdProfile(
    $input: DeleteShepherdProfileInput!
    $condition: ModelShepherdProfileConditionInput
  ) {
    deleteShepherdProfile(input: $input, condition: $condition) {
      assignedAt
      group
      profileId
      profile {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      shepherdId
      shepherd {
        id
        activeOrg
        alias
        learnUserId
        identityId
        status
        brStatus
        br
        brit
        city
        email
        firstName
        hireDate
        ismanager
        lastName
        level
        name
        site
        title
        manager
        l2manager
        l3manager
        brInterest
        diversityInterviewer
        loopInterest
        notifyLoopOpportunity
        notifyPhoneScreenOpportunity
        notifyWeeklyDigest
        phoneScreenInterest
        preferredTimezoneId
        lastRefreshedDate
        createdAt
        updatedAt
        __typename
      }
      isOrgDefault
      lastModifiedBy
      priority
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTraining = /* GraphQL */ `
  mutation CreateTraining(
    $input: CreateTrainingInput!
    $condition: ModelTrainingConditionInput
  ) {
    createTraining(input: $input, condition: $condition) {
      group
      id
      trainingId
      calibrationIds
      isActive
      isManaged
      isRequiredForloop
      isRequiredForPhoneScreen
      link
      minAcceptedVersion
      title
      trainingVersion
      orgId
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTraining = /* GraphQL */ `
  mutation UpdateTraining(
    $input: UpdateTrainingInput!
    $condition: ModelTrainingConditionInput
  ) {
    updateTraining(input: $input, condition: $condition) {
      group
      id
      trainingId
      calibrationIds
      isActive
      isManaged
      isRequiredForloop
      isRequiredForPhoneScreen
      link
      minAcceptedVersion
      title
      trainingVersion
      orgId
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTraining = /* GraphQL */ `
  mutation DeleteTraining(
    $input: DeleteTrainingInput!
    $condition: ModelTrainingConditionInput
  ) {
    deleteTraining(input: $input, condition: $condition) {
      group
      id
      trainingId
      calibrationIds
      isActive
      isManaged
      isRequiredForloop
      isRequiredForPhoneScreen
      link
      minAcceptedVersion
      title
      trainingVersion
      orgId
      org {
        id
        group
        name
        description
        geoarea
        georegion
        status
        availabilityMinDaysOut
        shadowMinDaysOut
        calibrationShepherdMode
        defaultCalibrationShepherd
        loopQuipID
        loopsExportedAt
        phoneScreenQuipID
        phoneScreensExportedAt
        orgQuipFolderID
        apssTeamId
        alwaysRestrictLeadSignups
        alwaysRestrictShadowSignups
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXV0YXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL19fZ2VuZXJhdGVkX18vbXV0YXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEIsMkRBQTJEO0FBRTNELE1BQU0sQ0FBQyxNQUFNLGdDQUFnQyxHQUFHLGFBQWEsQ0FBQzs7Ozs7OztDQU83RCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0seUJBQXlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7O0NBT3RELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwrQkFBK0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7OztDQVk1RCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Q0FTL0MsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7O0NBUy9DLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBaUJqRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0scUJBQXFCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7OztDQVFsRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7OztDQVE5QyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7OztDQVE5QyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0seUJBQXlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7OztDQWlCdEQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQW1CL0MsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBaUIxQyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FpQjFDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsYUFBYSxDQUFDOzs7O0NBSTFDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtQi9DLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtQi9DLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtQi9DLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXdCOUMsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBd0I5QyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3QjlDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBcUY1QyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXFGNUMsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FxRjVDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWtKMUMsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBa0oxQyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrSjFDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBc0w5QyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXNMOUMsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzTDlDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3SDNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3SDNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3SDNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E4VDVDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E4VDVDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E4VDVDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx1QkFBdUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWtCcEQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBa0JwRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sdUJBQXVCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQnBELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx1QkFBdUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBeUZwRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sdUJBQXVCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXlGcEQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F5RnBELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSw2QkFBNkIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBNkgxRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sNkJBQTZCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTZIMUQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLDZCQUE2QixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E2SDFELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBeUYvQyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXlGL0MsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F5Ri9DLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBc0k5QyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXNJOUMsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzSTlDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzRzFDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzRzFDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzRzFDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3RnRELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3RnRELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3RnRELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx3QkFBd0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXVGckQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLHdCQUF3QixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBdUZyRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sd0JBQXdCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F1RnJELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwyQkFBMkIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTJFeEQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLDJCQUEyQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBMkV4RCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sMkJBQTJCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0EyRXhELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBNEI1QyxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTRCNUMsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QjVDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQjNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQjNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQjNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtQjdDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtQjdDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtQjdDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzQjdDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzQjdDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzQjdDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F5QjlDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F5QjlDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F5QjlDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQ25ELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQ25ELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQ25ELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QnZELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QnZELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QnZELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QnRELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QnRELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QnRELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQ0FBaUMsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QjlELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQ0FBaUMsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QjlELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxpQ0FBaUMsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E0QjlELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBeUN2RCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sMEJBQTBCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXlDdkQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLDBCQUEwQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F5Q3ZELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwyQ0FBMkMsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0EyQ3hFLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwyQ0FBMkMsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0EyQ3hFLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSwyQ0FBMkMsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0EyQ3hFLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxtQ0FBbUMsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQW1EaEUsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLG1DQUFtQyxHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBbURoRSxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sbUNBQW1DLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtRGhFLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx1QkFBdUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXVDcEQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBdUNwRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sdUJBQXVCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F1Q3BELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBeUN0RCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0seUJBQXlCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXlDdEQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLHlCQUF5QixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F5Q3RELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWdKakQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBZ0pqRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FnSmpELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRyxhQUFhLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTBGbEQsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLHFCQUFxQixHQUFHLGFBQWEsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBMEZsRCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0scUJBQXFCLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0EwRmxELENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FnRDNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FnRDNDLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FnRDNDLENBQUMifQ==